import palette from '@/theme/palette';

export const styles = {
  popover: {
    ml: '-50px',
    li: {
      minWidth: '200px',
      padding: '10px 30px',
      fontSize: '14px',
    },
  },
  selectedItem: {
    bgcolor: palette.primary.main,
    color: palette.text.contrast,
    '&:hover': { bgcolor: palette.primary.main, color: palette.text.contrast },
  },
};
